const DIRS = ["n", "ne", "e", "se", "s", "sw", "w", "nw"] as const;
export type Compass8 = (typeof DIRS)[number];

/** Bucket a compass bearing (degrees, any range) into one of 8 points. */
export function compass8(deg: number): Compass8 {
  const norm = ((deg % 360) + 360) % 360;
  return DIRS[Math.round(norm / 45) % 8];
}
